var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("PortfolioOrDecisionNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.projectId },
      }),
      _vm._v(" "),
      _c(
        "form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.handleUpdateAlternativeLabelsCommand.apply(
                null,
                arguments
              )
            },
          },
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("hr", {
            staticStyle: { "border-color": "#bbb", margin: "20px 0 60px" },
          }),
          _vm._v(" "),
          _vm.rm
            ? _c("div", { staticClass: "container" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Single alternative:")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.rm.AlternativeLabel,
                        expression: "rm.AlternativeLabel",
                        modifiers: { trim: true },
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", required: "", minlength: "2" },
                    domProps: { value: _vm.rm.AlternativeLabel },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.rm,
                          "AlternativeLabel",
                          $event.target.value.trim()
                        )
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(
                      "What word would you like to use when talking about just one “alternative”?"
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Multiple alternatives:")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.rm.AlternativesLabel,
                        expression: "rm.AlternativesLabel",
                        modifiers: { trim: true },
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", required: "", minlength: "2" },
                    domProps: { value: _vm.rm.AlternativesLabel },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.rm,
                          "AlternativesLabel",
                          $event.target.value.trim()
                        )
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(
                      "What word would you like us to use for more than one “alternative”?"
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticClass: "container",
        staticStyle: { "margin-top": "80px", "padding-top": "40px" },
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-6" }, [
            _c(
              "h1",
              {
                staticStyle: {
                  "font-size": "2em",
                  "font-weight": "300",
                  color: "#33475b",
                  margin: "0",
                },
              },
              [_vm._v("Edit labels")]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-6 text-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-success",
                staticStyle: { padding: "0.7em 2em" },
                attrs: { type: "submit" },
              },
              [_vm._v("Save changes")]
            ),
          ]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "shadow-none p-3 mb-3 bg-light rounded" }, [
      _c("p", [
        _c("strong", [
          _vm._v(
            "You can replace the word “alternative” with a more relevant word like “car” or “vendor”."
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n                “Alternatives” is the word decision scientists use to describe the things you are choosing between.\n                Chances are, you’re not a decision scientist and you’re trying to choose between real-world “things” like cars, the potential sites of a new warehouse or a vendor.\n            "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }